import DesignList from './DesignList'

export default DesignList
